import { css } from 'lit';

export default css`
  :host {
    display: inline-flex;
    position: relative;
    font-family: var(--font-family-base);
    --tooltip-width: var(--menu-width);
    --tooltip-min-height: var(--menu-item-height);
    --tooltip-bg: var(--color-white);
    --tooltip-color: var(--base-text-color);
    --tooltip-border-radius: var(--radius-sm);
  }

  .trigger {
    display: inline-flex;
    align-items: center;
  }

  .tooltip {
    position: absolute;
    z-index: var(--z-index-tooltip);
    width: var(--tooltip-width);
    min-height: var(--tooltip-min-height);
    padding: var(--spacing-sm);
    border-radius: var(--tooltip-border-radius);
    border: 1px solid var(--color-gray-2);
    background: var(--tooltip-bg);
    color: var(--tooltip-color);
    box-shadow: var(--shadow-300);
    opacity: 0;
    visibility: hidden;
    transition: opacity 120ms ease, transform 120ms ease, visibility 120ms;
  }

  .text, ::slotted([slot="content"]) {
    display: block;
    font-size: var(--font-size-c1);
    line-height: var(--line-height-c1);
    word-break: break-word;
  }

  /* Positions */
  :host([position="bottom"]) .tooltip {
    top: 100%;
    left: calc(var(--tooltip-width) / 2);
    transform: translate(-50%);
  }
  :host([position="bottom"]:hover) .tooltip,
  :host([position="bottom"]:focus-within) .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, 0);
  }

  :host([position="top"]) .tooltip {
    bottom: 100% ;
    left: calc(var(--tooltip-width) / 2);
    transform: translate(-50%);
  }
  :host([position="top"]:hover) .tooltip,
  :host([position="top"]:focus-within) .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, 0);
  }

  :host([position="left"]) .tooltip {
    right: 100%;
    top: 50%;
    transform: translate(0, -50%);
  }
  :host([position="left"]:hover) .tooltip,
  :host([position="left"]:focus-within) .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translate(0, -50%);
  }

  :host([position="right"]) .tooltip {
    left: 100%;
    top: 50%;
    transform: translate(0, -50%);
  }
  :host([position="right"]:hover) .tooltip,
  :host([position="right"]:focus-within) .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translate(0, -50%);
  }

  @media (max-width: 768px) {
    .tooltip {
      padding: var(--spacing-xs);
    }
    .text, ::slotted([slot="content"]) {
      font-size: var(--font-size-c3);
      line-height: var(--line-height-c3);
    }
  }
`;